type HistoryObject = {
	pathname: string;
	search?: string;
	hash?: string;
};

export function getHistoryObject(path: string): HistoryObject {
	const url = new URL(path, window.location.origin);
	const historyObject = {} as HistoryObject;

	historyObject.pathname = url.pathname;
	if (url.search.length > 0) {
		historyObject.search = url.search;
	}
	if (url.hash.length > 0) {
		historyObject.hash = url.hash;
	}

	return historyObject;
}
